import ModalWrapper from 'dashboard/components/ModalWrapper';
import FormUpdateAccountStatus from 'dashboard/forms/FormUpdateAccountStatus';
import { ModalBody, ModalContainer, ModalHeader } from 'dashboard/layouts/ModalLayout';

const AccountStatusModal = ({
  isOpen,
  handleCloseModal,
  handleSubmit,
}: {
  isOpen: boolean;
  handleCloseModal: () => void;
  handleSubmit: ({ accountStatusId }: { accountStatusId: string }) => void;
}) => {
  return (
    <ModalWrapper
      isOpen={isOpen}
      handleCloseModal={handleCloseModal}
      shouldCloseOnEsc={true}
      shouldCloseOnOverlayClick={true}
    >
      <ModalContainer data-test='update-account-status-modal'>
        <ModalHeader data-test='update-account-status-modal__header' onClose={handleCloseModal}>
          Update account statuses
        </ModalHeader>

        <ModalBody>
          <FormUpdateAccountStatus handleClose={handleCloseModal} onSubmit={handleSubmit} />
        </ModalBody>
      </ModalContainer>
    </ModalWrapper>
  );
};

export default AccountStatusModal;
